import store from '../store/store';
import { mutatorAction } from 'satcheljs';

/**
 * Called when we toggle any of the checkboxes under Show work week as label,
 * updates the new calculated value for workDays in appearance option store
 * @workDays: new value for workDays setting
 */
export default mutatorAction('updateWorkWeekOption', function updateWorkWeekOption(
    workDays: number
) {
    let optionState = store();
    optionState.workDays = workDays;
});
